export const environment = {
  production: false,
  formUrl: 'https://forms.bmw.co.za/contact/int/bmw/finance'
};
